import { NotificationDefinition } from '../../types'
import { QuoteWebhookProcessingFailedHeader } from './QuoteWebhookProcessingFailedHeader'
import { QuoteWebhookProcessingFailedListItem } from './QuoteWebhookProcessingFailedListItem'
import { QuoteWebhookProcessingFailedPreview } from './QuoteWebhookProcessingFailedPreview'

export const quoteWebhookProcessingFailedDefinition: NotificationDefinition = {
  listItemContent: QuoteWebhookProcessingFailedListItem,
  previewHeaderContent: QuoteWebhookProcessingFailedHeader,
  previewContent: QuoteWebhookProcessingFailedPreview
}
